import { useContext, useState } from 'react';
import { Avatar, Box, IconButton, styled, Toolbar, Typography, useTheme } from '@mui/material';
import { Close, DarkMode, LightMode, Menu } from '@mui/icons-material';
import { EnvironmentLabel } from './EnvironmentLabel';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { TopMenuList } from '../../../routes/Menu';
import logo from '../../../assets/images/logo-small.png';
import { TopMenu } from './TopMenu';
import FullscreenToggleButton from './FullscreenToggleButton';
import { ColorModeContext } from '../../context/ColorMode/ColorModeContext';
import { MenuStateContext } from '../../context/MenuState/MenuStateContext';

const AnimatedIconWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '24px',
  height: '24px',
  '& .icon': {
    position: 'absolute',
    top: 0,
    left: 0,
    transition: 'opacity 0.3s ease, transform 0.3s ease',
  },
  '& .menuIcon': {
    opacity: 1,
    transform: 'rotate(0deg)',
  },
  '& .closeIcon': {
    opacity: 0,
    transform: 'rotate(90deg)',
  },
  '&.open .menuIcon': {
    opacity: 0,
    transform: 'rotate(-90deg)',
  },
  '&.open .closeIcon': {
    opacity: 1,
    transform: 'rotate(0deg)',
  },
}));

export const NavBarLayout = ({open, onToggleMenuMobile}) => {
  const theme = useTheme();
  const { toggleMenu } = useContext(MenuStateContext);
  const { mode, toggleColorMode } = useContext(ColorModeContext);
  const isDarkMode = mode === 'dark';

  const onToggleMenu = () => {
    toggleMenu();
    if(onToggleMenuMobile) onToggleMenuMobile();
  }

  return (
    <Toolbar sx={{ background: theme.palette.gradient.main }}>
      <IconButton
        color='inherit'
        aria-label='open drawer'
        edge='start'
        onClick={() => onToggleMenu()}
      >
        <AnimatedIconWrapper className={open ? 'open' : ''}>
          <Menu className='icon menuIcon' />
          <Close className='icon closeIcon' />
        </AnimatedIconWrapper>
      </IconButton>
      <Link
        to='/'
        style={{
          textDecoration: 'none',
          color: 'white',
          display: 'inline-flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '10px',
        }}
      >
        <Avatar alt='' src={logo} sx={{ filter: 'drop-shadow(3px 0px 3px rgba(0, 0, 0, .5))' }} />
        <Typography variant='h6' noWrap component='div'>
          Tableros OSER
        </Typography>
      </Link>
      <Box sx={{ flexGrow: 1 }} />
      <EnvironmentLabel />
      {/* Solo visible en desktop */}
      <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', ml: { xs: 0, md: 2 } }}>
        <FullscreenToggleButton />
        <IconButton
          aria-label='light'
          sx={{ color: isDarkMode ? 'white' : 'dark' }}
          onClick={() => {
            toggleColorMode();
          }}
        >
          {isDarkMode && <LightMode />}
          {!isDarkMode && <DarkMode />}
        </IconButton>
      </Box>
      <TopMenu list={TopMenuList} />
    </Toolbar>
  );
};
